export default __webpack_public_path__ + "static/media/proffesor-motoko-kiko-rounded.08b8f150.png";